const initialState = {
    cases: [], 
    account:[],
    
    
  
  };
  
  const DoctorReportsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA1_SUCCESS':
            return {... state, cases:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, account:action.payload};
           
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default DoctorReportsReducers;
  
  